import { usePOSBatchHandover } from "@easybiz/api-pos";
import { PROCEDURE_STORE_CHECK_OUT } from "@easybiz/utils";
import { Button } from "antd";
import React from "react";
import { FormattedMessage } from "react-intl";

export default ({ selects, procedure, onComplete }) => {
  const { onSubmit, loading } = usePOSBatchHandover((succeed, response) => {
    if (succeed) {
      onComplete(response.lines);
    }
  });

  return (
    <Button
      loading={loading}
      type={selects?.length > 0 ? "primary" : "default"}
      onClick={() =>
        onSubmit({
          procedure,
          orderIds: selects.map((select) => select.id),
        })
      }
    >
      {procedure === PROCEDURE_STORE_CHECK_OUT ? (
        <FormattedMessage tagName="span" defaultMessage="Check out" />
      ) : (
        <FormattedMessage tagName="span" defaultMessage="Check in" />
      )}
      {selects?.length ? ` (${selects.length})` : null}
    </Button>
  );
};
